<template>
  <div>
    <a-drawer
      title="修改内容"
      placement="right"
      :closable="true"
      :visible="visible"
      :mask="false"
      width="800"
      @close="closeDrawer"
    >
      <div>
        <div v-for="(record, index) in sellContractRecordList" :key="randomIndex(index)">
          <div v-for="(item, key) in sellContractRecord(record['modify_record'])" :key="key">
            <div v-if="key === 'unit_price_type_content'">
              <div v-if="sellContractRecord(record['modify_record'])['unit_price_type'] !== undefined">
                <a-row>
                  <a-col :span="12">
                    <div style="width: 100%;border: 1px solid #eeeeee; height: 260px; border-radius: 10px; padding: 5px; overflow-y: scroll">
                      <span v-for="(futures_contract, futures_contract_key) in item['before']" :key="futures_contract_key + randomIndex(1)">
                        <span class="single-item" v-if="futures_contract_key === 'exchange_rate_type'">
                          {{ transNameToCnNameWithData('exchange_rate_type', dictionaries.exchange_rate[futures_contract]) }}
                        </span>
                        <span class="single-item" v-else-if="futures_contract_key === 'unit_price_type'">
                          {{ transNameToCnNameWithData('unit_price_type', dictionaries.unit_price_type[futures_contract]) }}
                        </span>
                        <span class="single-item" v-else-if="futures_contract_key === 'pricing_currency'">
                          {{ transNameToCnNameWithData('pricing_currency', dictionaries.currency[futures_contract]) }}
                        </span>
                        <span class="single-item" v-else-if="futures_contract_key === 'receive_pricing_currency'">
                          {{ transNameToCnNameWithData('receive_pricing_currency', dictionaries.currency[futures_contract]) }}
                        </span>
                        <span class="single-item" v-else-if="futures_contract_key === 'is_tax_unit_price'">
                          {{ transNameToCnNameWithData('is_tax_unit_price', futures_contract ? '是' : '否') }}
                        </span>
                        <span class="single-item" v-else-if="futures_contract_key === 'is_tax_contract_amount'">
                          {{ transNameToCnNameWithData('is_tax_contract_amount', futures_contract ? '是' : '否') }}
                        </span>
                        <span class="single-item" v-else-if="futures_contract_key === 'is_expired'">
                          {{ transNameToCnNameWithData('is_expired', futures_contract ? '是' : '否') }}
                        </span>
                        <span class="single-item" v-else-if="futures_contract_key === 'is_priced'">
                          {{ transNameToCnNameWithData('is_priced', futures_contract ? '是' : '否') }}
                        </span>
                        <span class="single-item" v-else-if="futures_contract_key === 'fixed_date_rate'">
                          {{ transNameToCnNameWithData('fixed_date_rate', futures_contract === '1970-01-01' ? '无' : futures_contract) }}
                        </span>
                        <span v-else-if="futures_contract_key === 'futures_contract_list'">
                          <span v-for="(futures_contract_item, futures_contract_item_key) in futures_contract" :key="futures_contract_item_key + randomIndex(1024)">
                            <span v-for="(futures_contract_item_item, futures_contract_item_key) in futures_contract_item" :key="futures_contract_item_key + randomIndex(2024)">
                              <span v-if="transNameToCnName(futures_contract_item_key) !== undefined">
                                <span class="single-item" v-if="futures_contract_item_key === 'futures_contract'">
                                  {{ transNameToCnNameWithData('futures_contract', futures_contract_item_item === '1970-01-01' ? '无' : futures_contract_item_item.substring(0, futures_contract_item_item.lastIndexOf('-'))) }}
                                </span>
                                <span class="single-item" v-else-if="futures_contract_item_key === 'lock_up_date'">
                                  {{ transNameToCnNameWithData('lock_up_date', futures_contract_item_item === '1970-01-01' ? '无' : futures_contract_item_item) }}
                                </span>
                                <span v-else class="single-item" >
                                  {{ transNameToCnNameWithData(futures_contract_item_key, futures_contract_item_item) }}
                                </span>
                              </span>
                            </span>
                          </span>
                        </span>
                        <span v-else>
                          <span class="single-item">
                            {{ transNameToCnNameWithData(futures_contract_key, futures_contract) }}
                          </span>
                        </span>
                      </span>
                    </div>
                  </a-col>
                  <a-col :span="1">
                    <div style="height: 260px; line-height: 260px; text-align: center">-></div>
                  </a-col>
                  <a-col :span="11">
                    <div style="width: 100%;border: 1px solid #eeeeee; height: 260px; border-radius: 10px; padding: 5px; overflow-y: scroll">
                      <span v-for="(futures_contract, futures_contract_key) in item['after']" :key="futures_contract_key + randomIndex(1)">
                        <span class="single-item" v-if="futures_contract_key === 'exchange_rate_type'">
                          {{ transNameToCnNameWithData('exchange_rate_type', dictionaries.exchange_rate[futures_contract]) }}
                        </span>
                        <span class="single-item" v-else-if="futures_contract_key === 'unit_price_type'">
                          {{ transNameToCnNameWithData('unit_price_type', dictionaries.unit_price_type[futures_contract]) }}
                        </span>
                        <span class="single-item" v-else-if="futures_contract_key === 'pricing_currency'">
                          {{ transNameToCnNameWithData('pricing_currency', dictionaries.currency[futures_contract]) }}
                        </span>
                        <span class="single-item" v-else-if="futures_contract_key === 'receive_pricing_currency'">
                          {{ transNameToCnNameWithData('receive_pricing_currency', dictionaries.currency[futures_contract]) }}
                        </span>
                        <span class="single-item" v-else-if="futures_contract_key === 'is_tax_unit_price'">
                          {{ transNameToCnNameWithData('is_tax_unit_price', futures_contract ? '是' : '否') }}
                        </span>
                        <span class="single-item" v-else-if="futures_contract_key === 'is_tax_contract_amount'">
                          {{ transNameToCnNameWithData('is_tax_contract_amount', futures_contract ? '是' : '否') }}
                        </span>
                        <span class="single-item" v-else-if="futures_contract_key === 'is_expired'">
                          {{ transNameToCnNameWithData('is_expired', futures_contract ? '是' : '否') }}
                        </span>
                        <span class="single-item" v-else-if="futures_contract_key === 'is_priced'">
                          {{ transNameToCnNameWithData('is_priced', futures_contract ? '是' : '否') }}
                        </span>
                        <span class="single-item" v-else-if="futures_contract_key === 'fixed_date_rate'">
                          {{ transNameToCnNameWithData('fixed_date_rate', futures_contract === '1970-01-01' ? '无' : futures_contract) }}
                        </span>
                        <span v-else-if="futures_contract_key === 'futures_contract_list'">
                          <span v-for="(futures_contract_item, futures_contract_item_key) in futures_contract" :key="futures_contract_item_key + randomIndex(1024)">
                            <span v-for="(futures_contract_item_item, futures_contract_item_key) in futures_contract_item" :key="futures_contract_item_key + randomIndex(2024)">
                              <span v-if="transNameToCnName(futures_contract_item_key) !== undefined">
                                <span class="single-item" v-if="futures_contract_item_key === 'futures_contract'">
                                  {{ transNameToCnNameWithData('futures_contract', futures_contract_item_item === '1970-01-01' ? '无' : futures_contract_item_item.substring(0, futures_contract_item_item.lastIndexOf('-'))) }}
                                </span>
                                <span class="single-item" v-else-if="futures_contract_item_key === 'lock_up_date'">
                                  {{ transNameToCnNameWithData('lock_up_date', futures_contract_item_item === '1970-01-01' ? '无' : futures_contract_item_item) }}
                                </span>
                                <span v-else class="single-item" >
                                  {{ transNameToCnNameWithData(futures_contract_item_key, futures_contract_item_item) }}
                                </span>
                              </span>
                            </span>
                          </span>
                        </span>
                        <span v-else>
                          <span class="single-item">
                            {{ transNameToCnNameWithData(futures_contract_key, futures_contract) }}
                          </span>
                        </span>
                      </span>
                    </div>
                  </a-col>
                </a-row>
              </div>
              <div v-else>
                <span class="single-item" v-for="(child, key2) in item" :key="key2">
                  <span v-if="key2 === 'exchange_rate_type_content'">
                    <a-row>
                      <a-col span="12">
                        <div style="width: 100%;border: 1px solid #eeeeee; height: 100px; border-radius: 10px; padding: 5px; overflow-y: scroll">
                          <span v-for="(child2, key3) in child['before']" :key="key3" style="display: block">
                            <span>{{ transNameToCnNameWithData(key3, child2) }}</span>
                          </span>
                        </div>
                      </a-col>
                      <a-col span="1" style="height: 100px; line-height: 100px; text-align: center">
                        ->
                      </a-col>
                      <a-col span="11">
                        <div style="width: 100%;border: 1px solid #eeeeee; height: 100px; border-radius: 10px; padding: 5px; overflow-y: scroll">
                          <span v-for="(child2, key3) in child['after']" :key="key3">
                            <span>{{ transNameToCnNameWithData(key3, child2) }}</span>
                          </span>
                        </div>
                      </a-col>
                    </a-row>
                  </span>
                  <span v-else-if="key2 === 'exchange_rate_type'">
                    {{ transNameToCnNameWithData(key2, dictionaries.exchange_rate[child['before']]) }} -> {{ transNameToCnNameWithData(undefined, dictionaries.exchange_rate[child['after']]) }}
                  </span>
                  <span v-else>
                    {{ transNameToCnNameWithData(key2, child['before']) }} -> {{ transNameToCnNameWithData(undefined, child['after']) }}
                  </span>
                </span>
              </div>
            </div>
            <span class="single-item" v-else-if="key === 'payment_method_data_change'">
              <a-row>
                <a-col :span="11">
                  <div style="width: 100%;border: 1px solid #eeeeee; height: 120px; border-radius: 10px; padding: 5px 10px">
                    <span style="display: block">{{ transNameToCnNameWithData('payment_method', paymentMethodTitle(sellContractRecord(record['modify_record'])['payment_method']['before'])).replace('预付款方式：', '') }}</span>
                    <span class="single-item" v-for="(futures_contract, futures_contract_key) in item['before']" :key="futures_contract_key + randomIndex(3)">
                      <span class="single-item">
                        {{ transNameToCnNameWithData(futures_contract_key, futures_contract) }}
                      </span>
                    </span>
                  </div>
                </a-col>
                <a-col :span="2">
                  <div style="height: 120px; line-height: 120px; text-align: center">-></div>
                </a-col>
                <a-col :span="11">
                  <div style="width: 100%; border: 1px solid #eeeeee; height: 120px;border-radius: 10px; padding: 5px 10px">
                    <span style="display: block">{{ transNameToCnNameWithData('payment_method', paymentMethodTitle(sellContractRecord(record['modify_record'])['payment_method']['after'])).replace('预付款方式：', '') }}</span>
                    <span class="single-item" v-for="(futures_contract, after_futures_contract_key) in item['after']" :key="after_futures_contract_key + randomIndex(4)">
                      <span class="single-item">
                        {{ transNameToCnNameWithData(after_futures_contract_key, futures_contract) }}
                      </span>
                    </span>
                  </div>
                </a-col>
              </a-row>
            </span>
            <span class="single-item" v-else-if="key === 'balance_payment_method_data_change'">
              <a-row v-if="false">
                <a-col :span="11">
                  <div style="width: 100%;border: 1px solid #eeeeee; height: 160px; border-radius: 10px; padding: 5px 10px">
                    <span style="display: block">{{ transNameToCnNameWithData('balance_payment_method', balancePaymentMethodTitle(sellContractRecord(record['modify_record'])['balance_payment_method']['before'])).replace('尾款方式：', '') }}</span>
                    <span class="single-item" v-for="(futures_contract, futures_contract_key) in item['before']" :key="futures_contract_key + randomIndex(3)">
                      <span v-if="futures_contract_key === 'trade_balance_payment_date_method'">
                        {{ transNameToCnNameWithData(futures_contract_key, dictionaries.trade_balance_payment_date_method[futures_contract]) }}
                      </span>
                      <span v-else class="single-item">
                        {{ transNameToCnNameWithData(futures_contract_key, futures_contract) }}
                      </span>
                    </span>
                  </div>
                </a-col>
                <a-col :span="2">
                  <div style="height: 160px; line-height: 160px; text-align: center">-></div>
                </a-col>
                <a-col :span="11">
                  <div style="width: 100%; border: 1px solid #eeeeee; height: 160px;border-radius: 10px; padding: 5px 10px">
                    <span style="display: block">{{ transNameToCnNameWithData('balance_payment_method', balancePaymentMethodTitle(sellContractRecord(record['modify_record'])['balance_payment_method']['after'])).replace('尾款方式：', '') }}</span>
                    <span class="single-item" v-for="(futures_contract, after_futures_contract_key) in item['after']" :key="after_futures_contract_key + randomIndex(4)">
                      <span v-if="after_futures_contract_key === 'trade_balance_payment_date_method'">
                        {{ transNameToCnNameWithData(after_futures_contract_key, dictionaries.trade_balance_payment_date_method[futures_contract]) }}
                      </span>
                      <span v-else class="single-item">
                        {{ transNameToCnNameWithData(after_futures_contract_key, futures_contract) }}
                      </span>
                    </span>
                  </div>
                </a-col>
              </a-row>
            </span>
            <span class="single-item" v-else-if="key === 'product_parameter_data_change'">
              <a-row>
                <a-col :span="11">
                  <div style="width: 100%;border: 1px solid #eeeeee; height: 160px; border-radius: 10px; padding: 5px 10px; overflow-y: auto; max-height: 160px">
                    <span class="single-item" v-for="(futures_contract, futures_contract_key) in item['before']" :key="futures_contract_key + randomIndex(4)">
                      <span v-for="(pp, pp_key) in futures_contract" :key="pp_key + randomIndex(5)">
                        <span v-if="pp_key == 'symbol'">
                          {{ dictionaries.trade_value_compare_symbol[pp] }}
                        </span>
                        <span v-else>
                          {{ pp }}
                        </span>
                      </span>
                    </span>
                  </div>
                </a-col>
                <a-col :span="2">
                  <div style="height: 160px; line-height: 160px; text-align: center">-></div>
                </a-col>
                <a-col :span="11">
                  <div style="width: 100%; border: 1px solid #eeeeee; height: 160px;border-radius: 10px; padding: 5px 10px; overflow-y: auto; max-height: 160px">
                    <span class="single-item" v-for="(futures_contract, after_futures_contract_key) in item['after']" :key="after_futures_contract_key + randomIndex(4)">
                      <span v-for="(pp, pp_key) in futures_contract" :key="pp_key + randomIndex(5)">
                        <span v-if="pp_key == 'symbol'">
                          {{ dictionaries.trade_value_compare_symbol[pp] }}
                        </span>
                        <span v-else>
                          {{ pp }}
                        </span>
                      </span>
                    </span>
                  </div>
                </a-col>
              </a-row>
            </span>
            <span class="single-item" v-else-if="key === 'business_type'">
              {{ transNameToCnNameWithData('business_type', dictionaries.trade_contract_business_type[item['before']]) }} -> {{ transNameToCnNameWithData(undefined, dictionaries.trade_contract_business_type[item['after']]) }}
            </span>
            <span class="single-item" v-else-if="key === 'trade_type'">
              {{ transNameToCnNameWithData('trade_type', dictionaries.trade_types[item['before']]) }} -> {{ transNameToCnNameWithData(undefined, dictionaries.trade_types[item['after']]) }}
            </span>
            <span class="single-item" v-else-if="key === 'contract_date'">
              {{ transNameToCnNameWithData(key, item['before'] === '1970-01-01' ? '无' : item['before']) }} -> {{ transNameToCnNameWithData(undefined, item['after'] === '1970-01-01' ? '无' : item['after']) }}
            </span>
            <span class="single-item" v-else-if="key === 'latest_delivery_date'">
              {{ transNameToCnNameWithData(key, item['before'] === '1970-01-01' ? '无' : item['before']) }} -> {{ transNameToCnNameWithData(undefined, item['after'] === '1970-01-01' ? '无' : item['after']) }}
            </span>
            <span class="single-item" v-else-if="key === 'unit_price_type'">
              {{ transNameToCnNameWithData(key, dictionaries.unit_price_type[item['before']]) }} -> {{ transNameToCnNameWithData(undefined, dictionaries.unit_price_type[item['after']]) }}
            </span>
            <span class="single-item" v-else-if="key === 'exchange_rate'">
              {{ transNameToCnNameWithData(key, dictionaries.exchange_rate[item['before']]) }} -> {{ transNameToCnNameWithData(undefined, dictionaries.exchange_rate[item['after']]) }}
            </span>
            <span class="single-item" v-else-if="key === 'temp_unit_price'">
              {{ transNameToCnNameWithData(key, dictionaries.is_temp_unit_price[item['before']]) }} -> {{ transNameToCnNameWithData(undefined, dictionaries.is_temp_unit_price[item['after']]) }}
            </span>
            <span class="single-item" v-else-if="key === 'is_temp_exchange_rate'">
              {{ transNameToCnNameWithData(key, dictionaries.is_has[item['before']]) }} -> {{ transNameToCnNameWithData(undefined, dictionaries.is_has[item['after']]) }}
            </span>
            <span class="single-item" v-else-if="key === 'trade_balance_payment_date_method'">
              {{ transNameToCnNameWithData(key, dictionaries.trade_balance_payment_date_method[item['before']]) }} -> {{ transNameToCnNameWithData(undefined, dictionaries.trade_balance_payment_date_method[item['after']]) }}
            </span>
            <span class="single-item" v-else-if="key === 'pricing_currency'">
              {{ transNameToCnNameWithData(key, dictionaries.currency[item['before']]) }} -> {{ transNameToCnNameWithData(undefined, dictionaries.currency[item['after']]) }}
            </span>
            <span class="single-item" v-else-if="key === 'receive_pricing_currency'">
              {{ transNameToCnNameWithData(key, dictionaries.currency[item['before']]) }} -> {{ transNameToCnNameWithData(undefined, dictionaries.currency[item['after']]) }}
            </span>
            <span class="single-item" v-else-if="key === 'payment_method'">
              {{ transNameToCnNameWithData(key, paymentMethodTitle(item['before'])) }} -> {{ transNameToCnNameWithData(undefined, paymentMethodTitle(item['after'])) }}
            </span>
            <span class="single-item" v-else-if="key === 'tariff_type'">
              {{ transNameToCnNameWithData(key, taxTitle(item['before'])) }} -> {{ transNameToCnNameWithData(undefined, taxTitle(item['after'])) }}
            </span>
            <span class="single-item" v-else-if="key === 'consumption_tax_type'">
              {{ transNameToCnNameWithData(key, taxTitle(item['before'])) }} -> {{ transNameToCnNameWithData(undefined, taxTitle(item['after'])) }}
            </span>
            <span class="single-item" v-else-if="key === 'balance_payment_method'">
              <span v-if="false">
                {{ transNameToCnNameWithData(key, balancePaymentMethodTitle(item['before'])) }} -> {{ transNameToCnNameWithData(undefined, balancePaymentMethodTitle(item['after'])) }}
              </span>
            </span>
            <span class="single-item" v-else-if="key === 'tax_rate'">
              <span>
                {{ transNameToCnNameWithData(key, item['before']) }}% -> {{ transNameToCnNameWithData(undefined, item['after']) }}%
              </span>
            </span>
            <span class="single-item" v-else-if="key === 'transfer_info'">
              <span class="single-item">货转信息</span>
              <a-row>
                <a-col :span="12">
                  <div style="width: 100%;border: 1px solid #eeeeee; height: 260px; border-radius: 10px; padding: 5px; overflow-y: scroll">
                    <span class="single-item" v-if="item['before'] && item['before'] !== undefined && item['before'] !== null">
                      <span v-for="(futures_contract, futures_contract_key) in item['before']" :key="futures_contract_key + randomIndex(100)">
                        <span class="single-item" v-if="futures_contract_key === 'warehouse_stock_transfer_type'">
                          {{ transNameToCnNameWithData('warehouse_stock_transfer_type', dictionaries.trade_warehouse_stock_transfer_types[futures_contract]) }}
                        </span>
                        <span class="single-item" v-else-if="futures_contract_key === 'postpone_days_type'">
                          {{ transNameToCnNameWithData('postpone_days_type', futures_contract === 2 ? '工作日' : '天') }}
                        </span>
                        <span class="single-item" v-else-if="futures_contract_key === 'delivery_period_type'">
                          {{ transNameToCnNameWithData('delivery_period_type', dictionaries.trade_delivery_period_types[futures_contract]) }}
                        </span>
                        <span class="single-item" v-else-if="futures_contract_key === 'delivery_period_postpone_days_type'">
                          {{ transNameToCnNameWithData('delivery_period_postpone_days_type', futures_contract === 2 ? '工作日' : '天') }}
                        </span>
                        <span v-else>
                          <span class="single-item">
                            {{ transNameToCnNameWithData(futures_contract_key, futures_contract) }}
                          </span>
                        </span>
                      </span>
                    </span>
                  </div>
                </a-col>
                <a-col :span="1">
                  <div style="height: 260px; line-height: 260px; text-align: center">-></div>
                </a-col>
                <a-col :span="11">
                  <div style="width: 100%;border: 1px solid #eeeeee; height: 260px; border-radius: 10px; padding: 5px; overflow-y: scroll">
                    <span class="single-item">
                      <span v-for="(futures_contract, futures_contract_key) in item['after']" :key="futures_contract_key + randomIndex(100)">
                        <span class="single-item" v-if="futures_contract_key === 'warehouse_stock_transfer_type'">
                          {{ transNameToCnNameWithData('warehouse_stock_transfer_type', dictionaries.trade_warehouse_stock_transfer_types[futures_contract]) }}
                        </span>
                        <span class="single-item" v-if="futures_contract_key === 'goods_transfer_prerequisity'">
                          {{ transNameToCnNameWithData('goods_transfer_prerequisity', dictionaries.trade_sell_contract_goods_transfer_prerequisites[futures_contract]) }}
                        </span>
                        <span class="single-item" v-else-if="futures_contract_key === 'postpone_days_type'">
                          {{ transNameToCnNameWithData('postpone_days_type', futures_contract === 2 ? '工作日' : '天') }}
                        </span>
                        <span class="single-item" v-else-if="futures_contract_key === 'delivery_period_type'">
                          {{ transNameToCnNameWithData('delivery_period_type', dictionaries.trade_delivery_period_types[futures_contract]) }}
                        </span>
                        <span class="single-item" v-else-if="futures_contract_key === 'delivery_period_postpone_days_type'">
                          {{ transNameToCnNameWithData('delivery_period_postpone_days_type', futures_contract === 2 ? '工作日' : '天') }}
                        </span>
                        <span v-else>
                          <span class="single-item">
                            {{ transNameToCnNameWithData(futures_contract_key, futures_contract) }}
                          </span>
                        </span>
                      </span>
                    </span>
                  </div>
                </a-col>
              </a-row>
            </span>
            <span class="single-item" v-else-if="key === 'settlement_volume'">
              <span class="single-item">结算信息</span>
              <a-row>
                <a-col :span="12">
                  <div style="width: 100%;border: 1px solid #eeeeee; height: 100px; border-radius: 10px; padding: 5px; overflow-y: scroll">
                    <span class="single-item" v-if="item['before'] && item['before'] !== undefined && item['before'] !== null">
                      <span v-for="(futures_contract, futures_contract_key) in item['before']" :key="futures_contract_key + randomIndex(100)">
                        <span class="single-item" v-if="futures_contract_key === 'settlement_volume'">
                          {{ transNameToCnNameWithData('settlement_volume', dictionaries.trade_settlement_volume[futures_contract]) }}
                        </span>
                        <span v-else>
                          <span class="single-item">
                            {{ transNameToCnNameWithData(futures_contract_key, futures_contract) }}
                          </span>
                        </span>
                      </span>
                    </span>
                  </div>
                </a-col>
                <a-col :span="1">
                  <div style="height: 100px; line-height: 100px; text-align: center">-></div>
                </a-col>
                <a-col :span="11">
                  <div style="width: 100%;border: 1px solid #eeeeee; height: 100px; border-radius: 10px; padding: 5px; overflow-y: scroll">
                    <span class="single-item">
                      <span v-for="(futures_contract, futures_contract_key) in item['after']" :key="futures_contract_key + randomIndex(100)">
                        <span class="single-item" v-if="futures_contract_key === 'settlement_volume'">
                          {{ transNameToCnNameWithData('settlement_volume', dictionaries.trade_settlement_volume[futures_contract]) }}
                        </span>
                        <span v-else>
                          <span class="single-item">
                            {{ transNameToCnNameWithData(futures_contract_key, futures_contract) }}
                          </span>
                        </span>
                      </span>
                    </span>
                  </div>
                </a-col>
              </a-row>
            </span>
            <span class="single-item" v-else>
              {{ transNameToCnNameWithData(key, item['before']) }} -> {{ transNameToCnNameWithData(undefined, item['after']) }}
            </span>
          </div>
        </div>
      </div>
    </a-drawer>
  </div>
</template>

<script>
import { Dictionaries } from '@/common/AllConstant'
import { sell_contract_modify_record_list } from '@/api/trade_sell_contract'

export default {
  name: 'SellContractRecord',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    sellContract: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  computed: {
    taxTitle () {
      return (payment_method) => {
        return this.dictionaries.trade_tax_type[payment_method]
      }
    },
    paymentMethodTitle () {
      return (payment_method) => {
        return this.dictionaries.trade_pre_payment_method[payment_method]
      }
    },
    balancePaymentMethodTitle () {
      return (payment_method) => {
        return this.dictionaries.trade_balance_payment_method[payment_method]
      }
    },
    randomIndex () {
      return (index) => {
        return index + Math.random() * 10000000
      }
    },
    transNameToCnName () {
      return (name) => {
        if (undefined === name) {
          return ''
        }
        return this.sell_contract_key_to_name[name]
      }
    },
    transNameToCnNameWithData () {
      return (name, data) => {
        if (undefined === name) {
          return data
        }
        if (data === undefined || data === '1970-01-01' || data === null) {
          data = ''
        }
        return this.transNameToCnName(name) + '：' + data
      }
    },
    sellContractRecord () {
      return (json_data) => {
        return JSON.parse(json_data)
      }
    },
    turnedMonthFuturesContractLabel () {
      return (index) => {
        if (index === 0) {
          return '转月后期货合约'
        } else if (index === 1) {
          return '二次转月后期货合约'
        } else {
          return (index + 1) + '次转月后期货合约'
        }
      }
    },
    turnedMonthPricingPeriodLabel () {
      return (index) => {
        if (index === 0) {
          return '转月后默认计价期'
        } else if (index === 1) {
          return '二次转月后默认计价期'
        } else {
          return (index + 1) + '次转月后默认计价期'
        }
      }
    },
    turnedMonthLockUpDateLabel () {
      return (index) => {
        if (index === 0) {
          return '转月后锁价期限'
        } else if (index === 1) {
          return '二次转月后锁价期限'
        } else {
          return (index + 1) + '次转月后锁价期限'
        }
      }
    },
    isTruningMonthLabel () {
      return (index) => {
        if (index === 0) {
          return '是否可转月'
        } else if (index === 1) {
          return '是否可二次转月'
        } else {
          return '是否可' + (index + 1) + '次转月'
        }
      }
    }
  },
  data () {
    return {
      loading: false,
      dictionaries: Dictionaries,
      sellContractRecordList: [],
      sell_contract_key_to_name: {
        'contract_date': '合同日期',
        'trade_type': '贸易类型',
        'client': '客户',
        'product_name': '产品名称',
        'unit': '单位',
        'count': '数量',
        'spec': '规格型号',
        'trade_term': '贸易术语',
        'business_type': '业务类型',
        'delivery_address': '交货地',
        'pricing_currency': '计价币种',
        'receive_pricing_currency': '收款币种',
        'unit_price_type': '定价方式',
        'fixed_price': '固定价',
        'premium_discount': '升贴水',
        'price_fixing_fee': '点价费',
        'monthly_transfer_fee': '转月费',
        'floating_reference_basis': '浮动参考依据',
        'price_reference_period': '价格参考期限',
        'exchange_rate': '汇率',
        'exchange_rate_data_change': '汇率',
        'fixed_exchange_rate': '固定汇率',
        'fixed_date_rate': '确定日期汇率',
        'unfixed_date_rate': '其他日期汇率',
        'temp_unit_price': '是否有临时单价',
        'payment_method': '预付款方式',
        'balance_payment_method': '尾款方式',
        'payment_method_data_change': '预付款方式内容',
        'balance_payment_method_data_change': '尾款方式内容',
        'pre_payment': '预付款',
        'pre_payment_date': '预付款日期',
        'balance_payment': '尾款金额',
        'futures_contract_list': '点价',
        'futures_contract': '期货合约',
        'lock_up_date': '锁价期限',
        'trade_balance_payment_date_method': '尾款支付期限',
        'balance_payment_date': '确定尾款日期',
        'unbalance_payment_date_desc': '不确定尾款日期',
        'trade_balance_payment_days': '承兑日后',
        'pricing_period': '默认计价期',
        'trade_balance_payment_date_method_data_change': '尾款支付期限内容',
        'product_parameter_data_change': '产品参数内容',
        'name': '名称',
        'symbol': '符号',
        'standard_value': '值',
        'is_temp_exchange_rate': '是否有临时汇率',
        'temp_exchange_rate': '临时汇率',
        'quality_deduction_reason': '质量扣款依据',
        'exchange_rate_definition': '汇率定义方式',
        'unit_price': '单价',
        'is_tax_unit_price': '单价是否含税',
        'pricing_count': '数量',
        'contract_amount': '合同金额',
        'is_tax_contract_amount': '合同金额是否含税',
        'pace_date': 'PACE指数对应日期',
        'exchange_rate_type': '汇率类型',
        'is_priced': '是否已点价',
        'is_expired': '是否已过期',
        'warehouse': '仓库',
        'warehouse_stock_transfer_type': '入口货转类型',
        'goods_transfer_prerequisity': '货转前提条件',
        'postpone_days': '天数',
        'postpone_days_type': '天/工作日',
        'delivery_period_type': '提货期',
        'delivery_period_postpone_days': '天数',
        'delivery_period_postpone_days_type': '天/工作日',
        'undertaking_party': '超期责任人',
        'settlement_volume': '结算量',
        'custom_settlement_volume': '自定义结算量名称',
        'settlement_volume_content': '结算量内容',
        'latest_delivery_date': '最迟交货日期',
        'overloading_rate': '溢装率（%）',
        'shortage_rate': '短装率（%）',
        'pricing_source': '定价源',
        'tariff': '关税',
        'consumption_tax': '消费税',
        'tax_rate': '增值税率',
        'tariff_type': '关税类别',
        'consumption_tax_type': '消费税类别'
      }
    }
  },
  mounted () {
    this.loadModifyRecord()
  },
  methods: {
    closeDrawer () {
      this.$emit('close')
    },
    loadModifyRecord () {
      this.loading = true
      sell_contract_modify_record_list({ sell_contract_number: this.sellContract.number, to_version: this.sellContract.version }).then(res => {
        if (res.code === 1000) {
          this.sellContractRecordList = res.data.entries || []
        }
      }).finally(() => {
        this.loading = false
      })
    }
  }
}
</script>

<style scoped>
.single-item {
  padding-right: 20px;
  height: 40px;
  line-height: 40px;
  display: block;
}
</style>
